const carouselsMulti = document.querySelectorAll('.carousel__container_multi');

carouselsMulti.forEach(carousel => {
    const slider = carousel.querySelector('.carousel__slider_multi');
    const slides = carousel.querySelectorAll('.carousel__slide_multi');
    let currentIndex = 0;

    const leftArrow = carousel.querySelector('.carousel__arrow--left');
    const rightArrow = carousel.querySelector('.carousel__arrow--right');

    leftArrow.addEventListener('click', () => {
        currentIndex = currentIndex === 0 ? slides.length - getSlidesToShow() : Math.max(currentIndex - 1, 0);
        updateSliderPosition();
    });

    rightArrow.addEventListener('click', () => {
        const maxIndex = Math.max(slides.length - getSlidesToShow(), 0);
        currentIndex = (currentIndex + 1) % (maxIndex + 1);
        updateSliderPosition();
    });

    function updateSliderPosition() {
        const slideWidth = slides[0].offsetWidth + 20; // Including margin-right
        const slidesToShow = getSlidesToShow();
        const maxIndex = Math.max(slides.length - slidesToShow, 0);
        const translatedIndex = Math.min(currentIndex, maxIndex);
        slider.style.transform = `translateX(-${translatedIndex * slideWidth}px)`;
    }

    function getSlidesToShow() {
        const screenWidth = window.innerWidth;
        if (screenWidth < 768) {
            return 1;
        } else if (screenWidth < 1024) {
            return 2;
        } else if (screenWidth < 1200) {
            return 3;
        } else {
            return 4;
        }
    }
});

window.addEventListener('resize', () => {
    carouselsMulti.forEach(carousel => {
        const slides = carousel.querySelectorAll('.carousel__slide_multi');
        const slideWidth = slides[0].offsetWidth + 20; // Including margin-right
        const translatedIndex = Math.min(currentIndex, slides.length - 1);
        carousel.querySelector('.carousel__slider_multi').style.transform = `translateX(-${translatedIndex * slideWidth}px)`;
    });
});


// WEBPACK FOOTER //
// ./Components/Blocks/CarouselBlockMultiple/carouselMultiple.js